import axios from 'axios';
export const getTrainingSettings=(type:string) =>{
  return   axios.get(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-settings?where=`+type
  );
}
export const addTrainingSettings=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-settings/create`,
    obj,
    { headers }
  );
}

export const editTrainingSettings=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-settings/update`,
    obj,
    { headers }
  );
}

export const deleteTrainingSettings=(obj: Object) =>{
  const headers = {
    'Content-Type': 'application/json',
    
  };
  return axios.put(
    process.env.REACT_APP_API_GLOBAL_URL+`training-cert/training-settings/delete`,
    obj,
    { headers }
  );
}